import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { Flex, NumericInput, Selector, Text } from '@leverege/ui-elements';
import { GeoPointEditor } from '@leverege/ui-geo-elements';
import I18N from '@leverege/i18n';
import GeoPointCloserThanComparator from "./GeoPointCloserThanComparator.js";
import Constants from "./Constants.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  DISTANCE_OPTS
} = Constants;
const {
  t
} = I18N.ns('ui-attributes.condition.comparator.type.geoPoint.GeoPointDistanceComparatorEditor');
export default function ModelEditor(props) {
  const {
    value,
    usage,
    variant,
    toggleVariant,
    Model
  } = props;
  const distance = Model.getDistance(value);
  const value1 = Model.getValue1(value);
  const units = Model.getUnits(value);
  const onModelChange = useValueChange(Model, props);
  const style = usage === 'table' ? {
    width: '100%'
  } : null;
  const from = Model.TYPE === GeoPointCloserThanComparator.TYPE ? 'to' : 'from';
  return /*#__PURE__*/_jsxs(Flex, {
    style: style,
    variant: usage === 'table' ? 'colM' : 'rowM',
    align: usage === 'table' ? 'stretch' : 'center',
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      children: [/*#__PURE__*/_jsx(NumericInput, {
        onKeyDown: evt => {
          evt.stopPropagation();
        },
        style: {
          flexGrow: 1
        },
        variant: variant,
        float: true,
        eventData: "setDistance",
        onChange: onModelChange,
        value: distance
      }), /*#__PURE__*/_jsx(Selector, {
        variant: variant,
        toggleVariant: toggleVariant,
        value: units,
        values: DISTANCE_OPTS,
        onChange: onModelChange,
        eventData: "setUnits",
        title: renderer
      })]
    }), /*#__PURE__*/_jsx(Text, {
      variant: variant,
      children: t(from)
    }), /*#__PURE__*/_jsx(GeoPointEditor, {
      variant: variant,
      showMenu: false,
      showLabel: false,
      value: value1,
      eventData: "setValue1",
      onChange: onModelChange
    })]
  });
}
function renderer(item) {
  return item?.value == null ? item?.name || 'Default' : item.value;
}
ModelEditor.isInline = true;